import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { apiClient } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const CATEGORIES = [
  { key: null, label: "All" },
  { key: "mirrors", label: "Mirrors" },
  { key: "floorboards", label: "Floorboards" },
  { key: "apparel", label: "Apparel" },
];

export default function Shop() {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState("newest");

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (category) params.category = category;
    apiClient
      .get("/products", { params })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [category]);

  const sorted = [...products].sort((a, b) => {
    if (sortBy === "price-asc") return a.price - b.price;
    if (sortBy === "price-desc") return b.price - a.price;
    return 0;
  });

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16" data-testid="shop-page">
      <div className="mb-12">
        <div className="bgc-eyebrow text-[#c8102e]">THE SHOP</div>
        <h1 className="font-display text-6xl md:text-7xl tracking-tight uppercase mt-3">
          {category ? category : "All Products"}
        </h1>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-4 mb-10 border-b border-white/10 pb-6">
        <div className="flex flex-wrap gap-2">
          {CATEGORIES.map((c) => {
            const active = (category || null) === c.key;
            return (
              <Link
                key={c.label}
                to={c.key ? `/shop/${c.key}` : "/shop"}
                data-testid={`filter-${c.label.toLowerCase()}`}
                className={`px-4 py-2 text-xs tracking-[0.2em] uppercase font-display border transition-colors ${
                  active
                    ? "bg-[#c8102e] text-white border-[#c8102e]"
                    : "text-white border-white/20 hover:border-white"
                }`}
              >
                {c.label}
              </Link>
            );
          })}
        </div>
        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          className="input-dark"
          data-testid="shop-sort-select"
        >
          <option value="newest">Newest</option>
          <option value="price-asc">Price: Low to High</option>
          <option value="price-desc">Price: High to Low</option>
        </select>
      </div>

      {loading ? (
        <p className="text-[#9ca3af]">Loading…</p>
      ) : sorted.length === 0 ? (
        <p className="text-[#9ca3af]">No products found in this category yet.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="shop-grid">
          {sorted.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
